import { render, staticRenderFns } from "./AdministrationMenu.vue?vue&type=template&id=ac01838e"
import script from "./AdministrationMenu.vue?vue&type=script&lang=js"
export * from "./AdministrationMenu.vue?vue&type=script&lang=js"
import style0 from "./AdministrationMenu.vue?vue&type=style&index=0&id=ac01838e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports